import { Col, Layout, Row, Space } from 'antd';
import { Content, Header } from 'antd/lib/layout/layout';
import Image from 'next/image';
import { useRouter } from 'next/router';
import { FC, ReactNode, useContext, useEffect, useState } from 'react';
import { useAccessibilitySettings } from '../../hooks/use-accessibility-settings';
import { ScreenSizeContext } from '../../pages/_app';
import '../../styles/core.module.scss';
import { TENANT, Tenant } from '../../tenant/tenant';
import { HEADER_LOGO } from '../../tenant/tenant-logos';
import { Error } from '../error';
import { Meta } from '../Head/Meta';
import { AveliosSpinner } from '../loading/avelios-spinner';
import accessibilityStyles from './accessibility-override.module.scss';
import { AveliosFooter } from './footer';
import { Navigation } from './navigation';
import { PageAuth } from './page-auth';
import styles from './page-wrapper.module.scss';

export interface HeaderProps {
  title?: string;
  description?: string;
  keywords?: string[];
}

interface PageWrapperProps {
  reduced?: boolean;
  headerProps: HeaderProps | undefined;
  backgroundImage?: string;
  contentLoading?: boolean;
  error?: boolean;
  children: ReactNode;
}

export const PageWrapper: FC<PageWrapperProps> = ({
  reduced = false,
  headerProps,
  backgroundImage,
  contentLoading = false,
  error,
  children,
}) => {
  const [accessibilityModeActive] = useAccessibilitySettings();

  const router = useRouter();

  const [pageLoading, setPageLoading] = useState<boolean>(true);

  const [navClassName, setNavClassName] = useState(styles.header);

  const { isMobile } = useContext(ScreenSizeContext);

  useEffect(() => {
    setPageLoading(false);

    const handleScroll = () => {
      if (window.scrollY > 90) {
        setNavClassName(styles.headerBlur);
      } else {
        setNavClassName(styles.header);
      }
    };

    window.addEventListener('scroll', handleScroll);

    return () => {
      window.removeEventListener('scroll', handleScroll);
    };
  }, []);

  return (
    <>
      <Layout className={accessibilityModeActive ? accessibilityStyles.accessibility : undefined}>
        <Meta {...headerProps} />
        <Header className={!isMobile ? navClassName : styles.header}>
          <Row>
            <Col span={8} className={styles.alignLogo}>
              <Image
                alt={`${TENANT} Logo`}
                onClick={() => router.push('/home')}
                src={HEADER_LOGO}
                className={styles.logo}
                objectFit={'contain'}
                height={50}
                width={50}
              />
            </Col>
            <Col span={16} style={{ textAlign: 'right' }}>
              <Space>{!reduced && <Navigation />}</Space>
            </Col>
          </Row>
        </Header>

        {backgroundImage && (
          <div
            className={
              TENANT === Tenant.sana
                ? `${styles.backgroundImage} ${styles.backgroundImageSana}`
                : styles.backgroundImage
            }
          >
            <Image
              alt={'Avelios Medical Patientenportal'}
              priority
              src={backgroundImage}
              layout="fill"
              objectFit={'cover'}
            />
          </div>
        )}
        {/*<LegalGuardianHeader />*/}

        <Content style={{ padding: 12, marginTop: 64 }} className={styles.contentWrapper}>
          <div className={styles.content}>
            <AveliosSpinner spinning={contentLoading || pageLoading}>
              {error ? <Error /> : children}
            </AveliosSpinner>
          </div>
        </Content>

        <AveliosFooter />
      </Layout>
      <PageAuth />
    </>
  );
};
